/**
 * Strips all non-digit characters from a value intended for use in HTML context.
 * @param {*} value - The value to sanitize
 * @returns {string} String containing only digit characters
 */
export const sanitizeNumericId = value => String(value ?? '').replace(/\D/g, '');

/**
 * Strips characters not valid in an email address to prevent HTML injection.
 * @param {*} value - The value to sanitize
 * @returns {string} String containing only valid email characters
 */
export const sanitizeEmail = value => String(value ?? '').replace(/[^a-zA-Z0-9@._+\-]/g, '');

/**
 * HTML-encodes special characters in a value to prevent XSS when inserting
 * user-controlled text into HTML strings (e.g. dangerouslySetInnerHTML).
 * Not suitable for sanitizing URLs — javascript: hrefs are not blocked.
 * @param {*} value - The value to encode
 * @returns {string} HTML-encoded string safe for use as text content or attribute value
 */
export const sanitizeHtml = value =>
    String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
